import { Routes } from '@angular/router';
import { PAYLASIM_SISTEMI_ROUTES } from '@shared';

// Remote, shared'daki gerçek paylaşım sistemi route ağacını expose eder.
// Host (kabuk) `/paylasim` altında bunu yükler; child route'lar shared
// içindeki gerçek bileşenleri lazy load eder.
export const routes: Routes = PAYLASIM_SISTEMI_ROUTES;

